module.exports = __webpack_public_path__ + "static/media/incomming-call-icon.b832dcb8.svg";